<ng-container *ngIf="haveMedals == null || haveMedals == true">
  <div style="display: flex; align-items: center;justify-content: space-between;">
    <h2>{{ "Medals" | transloco }}</h2>
    <div class="link-container">
      <a class="link-results" [routerLink]="['results']" [queryParamsHandling]="'merge'">
        {{'Results' | transloco}}
      </a>
      <div class="arrow-link"></div>
    </div>
  </div>


<lib-filters-component [filters_options]="filterOptions"></lib-filters-component>
<ng-template #noResults>
  <div class="no-results not-found-research uppercase">{{'no_results_for_filter' | transloco}}</div>
</ng-template>
<ng-container

>
<ng-container *ngFor="let category of getKeys()">
  <ng-container *ngIf="property_data[category] as slickData">
    <ng-container *ngIf="category === property_selected">
    <ngx-slick-carousel
    *ngIf="slickData.config; else noResults"
    #carousel
    class="carousel"
    [config]="slickData.config"
    #slickModal="slick-carousel"
  >
    <ng-container>
      <div
       *ngFor="let medal of slickData.data"
        class="medals-wrapper"
        ngxSlickItem
      >
        <div class="medals-container">
          <div *ngIf="medal.gold !== 0">
            <div class="position medal-gold"></div>
            <div>{{ medal.gold }}</div>
          </div>
          <div *ngIf="medal.silver !== 0">
            <div class="position medal-silver"></div>
            <div>{{ medal.silver }}</div>
          </div>
          <div *ngIf="medal.bronze !== 0">
            <div class="position medal-bronze"></div>
            <div>{{ medal.bronze }}</div>
          </div>
        </div>
        <div>
          <div class="decoration"></div>
          <div class="medal-category">
            {{ medal.ComDescription | transloco }}
          </div>
        </div>
      </div>
    </ng-container>

  </ngx-slick-carousel>
</ng-container>
  </ng-container>

</ng-container>

</ng-container>

</ng-container>
